import "../../../styles/Pages/Produits/Veilleuses/mochi.css";
import { useState, useEffect, useRef } from "react";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../../Firebase/firebase-config";
import { addProductToPanier } from "../../../Firebase/panier";
import { useAuth } from "../../../context/AuthContext";
import axios from "axios";
import FirstMochi from "../../../assets/Pages/Produits/Veilleuses/Mochi/Mochifirst.png"; 
import ProductComponent from "../../../Composants/Product/ProductComponent";
import { useFlyToCart } from "../../../hooks/useFlyToCart";
import { useToast } from "../../../context/ToastContext";
import { useCartCount } from "../../../context/CartContext";
import vertynoLogo from "../../../assets/Pages/Produits/Veilleuses/Mochi/vertynoLogo.png";
import mochiBack from "../../../assets/Pages/Produits/Veilleuses/Mochi/mochiBack.png";
import yeuxmochi from "../../../assets/Pages/Produits/Veilleuses/Mochi/yeuxmochi.png";
import mochiOne from "../../../assets/Pages/Produits/Veilleuses/Mochi/mochiOne.png";
import mochiTwo from "../../../assets/Pages/Produits/Veilleuses/Mochi/mochiTwo.png";
import mochiGround from "../../../assets/Pages/Produits/Veilleuses/Mochi/mochiGround.png";
import mochiThree from "../../../assets/Pages/Produits/Veilleuses/Mochi/mochiThree.png";
import mochiQuatre from "../../../assets/Pages/Produits/Veilleuses/Mochi/mochiQuatre.png";
import mochiFive from "../../../assets/Pages/Produits/Veilleuses/Mochi/mochiFive.png";
import imgFicheMochi from "../../../assets/Pages/Produits/Veilleuses/Mochi/imgFicheMochi.png";

// 🔹 Fonction pour ajouter l'email à Brevo
async function addEmailToBrevo(email) {
  try {
    await axios.post(
      "https://api.brevo.com/v3/contacts",
      {
        email: email,
        updateEnabled: true,
      },
      {
        headers: {
          "api-key": process.env.REACT_APP_BREVO_API_KEY,
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Email ajouté à Brevo !");
  } catch (error) {
    console.error("Erreur ajout Brevo :", error.response?.data || error);
    throw error;
  }
}

export default function MochiLePanda () {

  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [ficheQuantity, setFicheQuantity] = useState(1);
  // State pour l'email dans la section "order-section"
  const [orderEmail, setOrderEmail] = useState("");
  
  // Refs pour les boutons "Commander" (pour l'animation)
  const heroButtonRef = useRef(null);
  const ficheCtaRef = useRef(null);
  const packagingButtonRef = useRef(null);
  
  // Hook pour l'animation de vol vers le panier
  const flyToCart = useFlyToCart();
  const { showToast } = useToast();
  const { openCartDrawer } = useCartCount();
  const { uid } = useAuth();

  const handleAddToCart = async (buttonRef, quantity = 1) => {
    if (!selectedProduct) {
      console.warn("Aucun produit sélectionné");
      return;
    }

    // Récupération du bouton panier dans le Header (via son ID)
    const panierButton = document.getElementById("panier-button");
    
    // Déclenchement de l'animation si les deux boutons sont trouvés
    if (buttonRef?.current && panierButton) {
      flyToCart(buttonRef.current, panierButton);
    }

    // Ajout du produit dans Firestore (l'animation se joue en parallèle)
    try {
      if (!uid) {
        showToast("Connexion en cours… Réessayez dans un instant.");
        return;
      }
      await addProductToPanier(selectedProduct, uid, quantity);
      console.log("Produit ajouté dans Firestore :", selectedProduct.name);
      showToast(quantity > 1 ? `${quantity} produits ajoutés au panier` : "Produit ajouté au panier");
      openCartDrawer();
    } catch (error) {
      console.error("Erreur lors de l'ajout dans Firestore :", error);
    }
  };

  const decrementFicheQuantity = () => {
    setFicheQuantity((prev) => Math.max(1, prev - 1));
  };

  const incrementFicheQuantity = () => {
    setFicheQuantity((prev) => Math.min(99, prev + 1));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % 3);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  /**
   * Section order-section : inscription newsletter (Firestore + Brevo), sans ajout au panier.
   */
  const handleOrder = async () => {
    if (!orderEmail || !orderEmail.trim()) {
      showToast("Veuillez saisir votre email");
      return;
    }

    try {
      if (!uid) {
        showToast("Connexion en cours… Réessayez dans un instant.");
        return;
      }

      await addDoc(collection(db, "newsletter"), {
        email: orderEmail.trim(),
        createdAt: serverTimestamp(),
        source: "mochilepanda-order",
      });

      try {
        await addEmailToBrevo(orderEmail.trim());
      } catch (brevoError) {
        console.warn("Erreur Brevo (non bloquant) :", brevoError);
      }

      showToast("Merci ! Votre inscription a bien été enregistrée.");
      setOrderEmail("");
    } catch (error) {
      console.error("Erreur lors de l'inscription :", error);
      showToast("Une erreur est survenue. Réessayez.");
    }
  };

  return (
    <>
      <div className="mochi-page">
        <ProductComponent
          slug="mochilepanda"
          onProductReady={(product) => setSelectedProduct(product)}
        />
        <div className="hero-section">
          <img src={FirstMochi} alt="Veilleuse Mochi le panda" className="hero-img" />
          <div className="hero-content">
            <h1 className="hero-title">Mochi le panda</h1>
            <button 
              type="button" 
              className="hero-button-mochi" 
              ref={heroButtonRef}
              onClick={() => handleAddToCart(heroButtonRef)}
            >
              Commander
            </button>
          </div>
        </div>

        <section className="mochi-product-fiche" aria-labelledby="mochi-fiche-title">
          <div className="mochi-product-fiche__inner">
            <div className="mochi-product-fiche__media">
              <img
                src={imgFicheMochi}
                alt="Veilleuse Mochi le panda, silhouette sur fond transparent"
                className="mochi-product-fiche__img"
                width={600}
                height={600}
                loading="lazy"
              />
            </div>
            <div className="mochi-product-fiche__card">
              <h2 id="mochi-fiche-title" className="mochi-product-fiche__title">
                <strong className="confmochi">Mochi le panda</strong>
              </h2>

              <p className="mochi-product-fiche__price" aria-label="Prix">
                {selectedProduct != null
                  ? `${String(selectedProduct.price.toFixed(2)).replace(".", ",")} €`
                  : "21,90 €"}
              </p>

              <div className="mochi-product-fiche__actions">
                <div className="mochi-product-fiche__qty" aria-label="Choix de la quantité">
                  <button type="button" onClick={decrementFicheQuantity} disabled={ficheQuantity <= 1}>-</button>
                  <span>{ficheQuantity}</span>
                  <button type="button" onClick={incrementFicheQuantity} disabled={ficheQuantity >= 99}>+</button>
                </div>
                <button
                  type="button"
                  className="mochi-product-fiche__cta"
                  ref={ficheCtaRef}
                  onClick={() => handleAddToCart(ficheCtaRef, ficheQuantity)}
                >
                  AJOUTER AU PANIER
                </button>
              </div>

              <ul className="mochi-product-fiche__shipping" aria-label="Informations livraison">
                <li>
                  <span className="mochi-product-fiche__check" aria-hidden="true">
                    ✓
                  </span>
                  Livraison point relais gratuite (Chrono Shop2Shop)
                </li>
              </ul>

              <ul className="mochi-product-fiche__infos">
                <li className="mochi-product-fiche__stock-line">
                  <i className="bi bi-circle-fill" aria-hidden="true" /> En stock
                </li>
                <li><i className="bi bi-arrow-repeat" aria-hidden="true" /> LIVRAISON OFFERTE EN POINT RELAIS</li>
                <li><i className="bi bi-shield-lock" aria-hidden="true" /> Paiement sécurisé</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="mochi-text-section">
          <section className="presentation-section-mochi">
            <div className="image-logo-and-patte">
              <img src={yeuxmochi} alt="Icône" className="imgCent rainbow" />
              <img src={vertynoLogo} alt="Logo Vertyno" className="vertyno-logo " />
            </div>
            <h2 className="presentation-title-mochi">Mochi, le compagnon des nuits sereines </h2>
            <article className="presentation-text-area-mochi">
             <p className="presentation-text-mochi">
  <strong className="confmochi">Mochi</strong>, le compagnon des nuits sereines — une douceur signée VERTYNO
  Avec son regard malicieux et sa lumière apaisante, <strong className="confmochi">Mochi</strong> veille sur les tout-petits.
  Conçu en silicone moelleux sans BPA, il est aussi doux à câliner qu’agréable à regarder.
  D’un simple tapotement, il diffuse une lueur réconfortante, idéale pour apaiser les nuits et accompagner les rêves.
  Une bulle de douceur, signée VERTYNO.
</p>
              <img src={mochiBack} alt="Mochi le panda lumineux" className="mochi-doudou-img" />
            </article>
          </section>
        </section>

        <section className="double-image-section-mochi">
          <div className="double-image-content-mochi">
            <img src={mochiOne} alt="image_de_la_veilleuse_mochi" className="widthimage" />
            <img src={mochiTwo} alt="image_de_la_veilleuse_mochi" className="widthimage" />
          </div>
        </section>

        <section className="advantages-and-order-mochi">
          <div className="advantages-section">
            <h2 className="confiteria advantages-title">Mochi le panda</h2>
            <div className="advantages-list">
              <div className="advantage-item">
                <div className={`advantage-bar ${activeIndex === 0 ? 'active' : ''}`}></div>
                <h3>Sécurité</h3>
                <p>Silicone alimentaire sans BPA et LED sans danger pour les yeux.</p>
              </div>
              <div className="advantage-item">
                <div className={`advantage-bar ${activeIndex === 1 ? 'active' : ''}`}></div>
                <h3>Qualité</h3>
                <p>Doux, résistant et lumière apaisante pour un sommeil serein.</p>
              </div>
              <div className="advantage-item">
                <div className={`advantage-bar ${activeIndex === 2 ? 'active' : ''}`}></div>
                <h3>Éco-responsable</h3>
                <p>Rechargeable, et fait pour durer.</p>
              </div>
            </div>
          </div>

          <div className="order-section">
            <div className="order-content-mochi">
            <h3>Rejoignez notre bulle de douceur</h3>
              <p>
                Laissez <strong className="confdino">Dino</strong> veiller sur les nuits de votre enfant 
avec tendresse. Inscrivez-vous pour faire partie de la famille Vertyno : recevez nos 
inspirations pour des couchers apaisés, découvrez nos nouveautés en avant-première et profitez 
de petites attentions exclusives, imaginées juste pour vous.
                 </p>
              <label htmlFor="email">adresse email :</label>
              <input 
                type="email" 
                id="email" 
                placeholder="saisir" 
                value={orderEmail}
                onChange={(e) => setOrderEmail(e.target.value)}
              />
              <button 
                type="button" 
                onClick={handleOrder}
              >
               Rejoignez-nous
              </button>
            </div>
            <img src={mochiGround} alt="Veilleuse Mochi" className="order-image" />
          </div>
        </section>

        <section className="mochiimageandtext">
          <img src={mochiThree} alt="image_des_caracteristiques_de_mochi" className="widthimage" />
        </section>

        <section className="mochi-magie-text">
  <h2>
    <span className="confiteria">Mochi</span>, le panda veilleur des nuits – une magie VERTYNO
  </h2>
  <p>
    <span className="confiteria">Mochi</span>, le panda malicieux, s’adapte à chaque moment de la nuit. Avec ses 7 couleurs changeantes, 
    il crée une ambiance unique : une lumière douce pour l’endormissement, un éclairage rassurant pour les réveils nocturnes, 
    ou une touche ludique pour les rêves éveillés. Pratique et sécurisé, <span className="confiteria">Mochi</span> accompagne chaque nuit avec douceur.
  </p>
</section>


        <section className="mochi-section-quatreimg">
          <img src={mochiQuatre} alt="image_de_couleurs_de_mochi" className="widthimage dispFlex" />
        </section>

        <section className="mochi-caracteristiques">
  <h2>Caractéristiques de <span className="confiteria">Mochi le panda</span></h2>

  <div className="caracteristiques-grid">
    <div className="carac-item">Niveaux d’intensité<br /><strong className="reglage">Réglable,<br /> BLANCHE</strong></div>
    <div className="carac-item">Autonomie<br /><strong className="reglage">Jusqu’à une nuit <br /> de sommeil</strong></div>
    <div className="carac-item">Capacité<br /><strong className="reglage">1200 mAH</strong></div>

    <div className="caracteristiques-divider"></div>

    <div className="carac-item">Mode lumineux<br /><strong className="reglage">7 couleurs<br /> changeantes</strong></div>
    <div className="carac-item">Lumière<br /><strong className="reglage">Douce à 360°</strong></div>
    <div className="carac-item">Contrôle<br /><strong className="reglage">Par tapotement</strong></div>

    <div className="caracteristiques-divider"></div>

    <div className="carac-item">Minuterie<br /><strong className="reglage">30 minutes</strong></div>
    <div className="carac-item">Batterie<br /><strong className="reglage">Rechargeable <br />via USB</strong> <small>(câble inclus)</small></div>
    <div className="carac-item">Sécurité<br /><strong className="reglage">Sans BPA, en silicone alimentaire, sans danger pour les yeux</strong></div>

    <div className="caracteristiques-divider"></div>

    <div className="carac-item unique">Matière<br /><strong className="reglage">Silicone doux <br />et moelleux</strong></div>
  </div>

  <div className="guide-utilisation">
    <h3>Guide d’utilisation</h3>
    <p>
      Appuyez légèrement sur <strong className="confmochi">Mochi</strong> pour l’allumer ou varier l’intensité.
      Son mode multicolore apporte une touche de magie avant le coucher.
      Les couleurs défilent une à une : tapotez au moment où celle que vous aimez apparaît pour la figer.
      Activez le minuteur pour qu’il s’éteigne tout seul après un moment, 
      et laissez <strong className="confdino">Mochi</strong> veiller sur votre enfant toute la nuit.
    </p>
  </div>
</section>



        <section className="mochi-packaging">
          <img
            src={mochiFive}
            alt="Boîte Mochi le panda"
            className="packaging-box-img widthimage"
          />
          <div className="packaging-btns">
            <button
              className="white-outline-btn"
              type="button"
              ref={packagingButtonRef}
              onClick={() => handleAddToCart(packagingButtonRef)}
            >
              Commander
            </button>
            <button className="white-outline-btn"><a href={"/Contact"}>Contact</a></button>
          </div>
        </section>
      </div>
    </>
  );
}
